/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { EMAService, EMAService$inboundSchema } from "./emaservice.js";

/**
 * Every service identity chaining reaches in the organization.
 */
export type ListEMAServicesResult = {
  items: Array<EMAService>;
};

/** @internal */
export const ListEMAServicesResult$inboundSchema: z.ZodMiniType<
  ListEMAServicesResult,
  unknown
> = z.object({
  items: z.array(EMAService$inboundSchema),
});

export function listEMAServicesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListEMAServicesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEMAServicesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEMAServicesResult' from JSON`,
  );
}
